import { DetalhesImportacaoVendaConsignatarioDtoModel } from "./../../../models/importacaoVendaConsignatario/detalhesImportacaoVendaConsignatarioDtoModel";
import { createSlice } from "@reduxjs/toolkit";
import { BuscarImportacaoVendaConsignatarioModel } from "../../../models/importacaoVendaConsignatario/buscarImportacaoVendaConsignatarioModel";
import { buscarImportacaoVendaConsignatario } from "../../../services/importacaoVendaConsignatarioService";
import { resetAll } from "../../actions/actions";

export interface ImportacaoVendaConsignatarioState {
  //buscar importacao venda consignatario
  loading: boolean;
  busca: BuscarImportacaoVendaConsignatarioModel;
  list: DetalhesImportacaoVendaConsignatarioDtoModel[];
  entity: DetalhesImportacaoVendaConsignatarioDtoModel;
  //internal
  modalConfirmar: boolean;
}

const initialState: ImportacaoVendaConsignatarioState = {
  //buscar importacao venda consignatario
  loading: false,
  busca: {
    idEmpresa: null,
    idSorteio: null,
  } as BuscarImportacaoVendaConsignatarioModel,
  list: [],
  entity: {} as DetalhesImportacaoVendaConsignatarioDtoModel,
  //internal
  modalConfirmar: false,
};

export const importacaoVendaConsignatarioSlice = createSlice({
  name: "importacaoVendaConsignatario",
  initialState,
  reducers: {
    //buscar importacao venda consignatario
    setBuscaImportacaoVendaConsignatario: (state, action) => {
      state.busca = action.payload;
    },
    setEntityImportacaoVendaConsignatario: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalConfirmarImportacaoVendaConsignatario: (state, action) => {
      state.modalConfirmar = action.payload;
    },
    resetImportacao: () => initialState,
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar importacao venda consignatario
    builder.addCase(buscarImportacaoVendaConsignatario.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarImportacaoVendaConsignatario.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarImportacaoVendaConsignatario.rejected, (state, action) => {
      state.loading = false;
      state.list = [];
    });
  },
});

export const {
  //buscar importacao venda consignatario
  setBuscaImportacaoVendaConsignatario,
  setEntityImportacaoVendaConsignatario,
  //internal
  setModalConfirmarImportacaoVendaConsignatario,
  resetImportacao,
} = importacaoVendaConsignatarioSlice.actions;
export default importacaoVendaConsignatarioSlice.reducer;
